var Component = require('./../../Component');
var $ = require('jQuery');

var Plugin = function (options) {
    Component.call(this, options);

    (function (self) {
        self._element.addClass('im-plugin');
    })(this);

    this._input = null;
    if(navigator.userAgent.indexOf("MSIE 7.0")>0||navigator.userAgent.indexOf("MSIE 8.0")>0){
        this._win=document;
    }else{
        this._win=window;
    }
};
Plugin.prototype = Object.create(Component.prototype);
Plugin.prototype.render = function () {
    if (this._data.opened) {
        this._element.addClass('im-opened');
    }
    else {
        this._element.removeClass('im-opened');
    }
};
Plugin.prototype.open = function () {
    this._opened = true;
    this.setData(
        {
            opened: true
        });
};
Plugin.prototype.close = function () {
    this._opened = false;
    this.setData(
        {
            opened: false
        });
};
Plugin.prototype.setInput = function (input) {
    return this._input = input;
};

module.exports = Plugin;
